import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const AUTH_TOKEN = 'FeMsA@2024';

export interface MapClient {
  id: string;
  name: string;
  channel: string;
  gec: string;
  longitude: string;
  latitude: string;
}

export interface PolygonPoint {
  lat: number;
  lng: number;
}

export const getClientsByLocation = async (lat: string, lng: string): Promise<MapClient[]> => {
  try {
    // const token = localStorage.getItem('token');
   
    const response = await axios.post(
      `${API_URL}/maps/clients`,
      {
        lat,
        long: lng
      },
      {
        headers: {
          'Authorization': `Bearer ${AUTH_TOKEN}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching clients by location:', error);
    throw error;
  }
};

interface PolygonClientsResponse {
  success: boolean;
  res: string;
  data: Array<{
    id: string;
    name: string;
  }>;
}

export const getClientsByPolygon = async (points: PolygonPoint[]): Promise<PolygonClientsResponse> => {
  try {
    const response = await axios.post<PolygonClientsResponse>(
      `${API_URL}/polygon/clients`,
      {
        data: points
      },
      {
        headers: {
          'Authorization': `Bearer ${AUTH_TOKEN}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching clients by polygon:', error);
    throw error;
  }
};

// Polygon statistics
export interface PolygonStatsSummaryItem {
  category: string;
  qty: string | number;
}

export interface PolygonStatsDailyItem {
  category: string;
  qty: string | number;
  date_part: number;
}

export interface PolygonStatsResponse {
  success: boolean;
  stats: {
    summary: PolygonStatsSummaryItem[];
    daily: PolygonStatsDailyItem[];
  };
}

export const getPolygonStats = async (points: PolygonPoint[]): Promise<PolygonStatsResponse> => {
  try {
    const response = await axios.post<PolygonStatsResponse>(
      `${API_URL}/polygon/stats`,
      {
        data: points
      },
      {
        headers: {
          'Authorization': `Bearer ${AUTH_TOKEN}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching polygon stats:', error);
    throw error;
  }
};
